import React from 'react';
import { Clock, Users, ShieldCheck, Copyright } from 'lucide-react';

const bottomFeatures = [
  {
    icon: Clock,
    title: 'Attendance',
    subtitle: 'Real-time Tracking',
  },
  {
    icon: Users,
    title: 'Employee Portal',
    subtitle: 'Self Service',
  },
  {
    icon: ShieldCheck,
    title: 'Enterprise Ready',
    subtitle: 'Role Based Access',
  },
  {
    icon: Copyright,
    title: '2026 Mobiloitte',
    subtitle: 'All Rights Reserved',
  },
];

const BottomFeatures = () => {
  return (
    <div className="relative w-full px-4 sm:px-8 lg:px-16 py-3 sm:py-3.5 bg-[#0F2147] border-t border-white/10 overflow-hidden shadow-lg">
      {/* Radial grid dot pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.15] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, #60A5FA 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />

      <div className="relative z-10 max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-y-3.5 sm:gap-y-4 gap-x-2 sm:gap-x-4">
        {bottomFeatures.map((feature, index) => (
          <div
            key={feature.title}
            className="flex items-center justify-center gap-2.5 sm:gap-3.5 px-2 sm:px-4 relative group min-w-0"
          >
            {/* Divider line between items on desktop */}
            {index > 0 && (
              <div className="hidden lg:block absolute left-0 top-1/2 -translate-y-1/2 w-px h-8 bg-white/15" />
            )}
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white/10 border border-white/15 backdrop-blur-md shadow-sm flex items-center justify-center flex-shrink-0 group-hover:bg-white/20 group-hover:border-white/30 transition-all duration-300">
              <feature.icon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-300 group-hover:text-white transition-colors" strokeWidth={1.8} />
            </div>
            <div className="min-w-0">
              <p className="text-white text-xs sm:text-sm font-semibold font-sans leading-tight tracking-tight truncate" title={feature.title}>
                {feature.title}
              </p>
              <p className="text-blue-200/80 text-[10px] sm:text-xs font-medium font-sans leading-tight mt-0.5 truncate" title={feature.subtitle}>
                {feature.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BottomFeatures;
